import React from "react";
import { PlusOutlined } from "@ant-design/icons";
import {
  Drawer,
  Button,
  PageHeader,
} from "antd";
import { useState } from "react";




import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";

import { ADD_MODE, DEFAULT_MASTER_DRAWER_WIDTH } from "../../utility/Constants";



import PaymentModeEntry from "../../components/masters/payment_mode/PaymentModeEntry";
import PaymentModeList from "../../components/masters/payment_mode/PaymentModeList";
import DrawableCloseIcon from "../../components/common/DrawableCloseIcon";

const PaymentMode = () => {
    const [visible, setVisible] = useState(false);
    const [paymentModeAddData, setPaymentModeAddData] = useState({
     id: 0,
     payment_mode: '',
     account_id: '',
     mode: ADD_MODE,
     bank_charges:0,
     is_bank_details: 'N',
    });
  
    const showDrawer = () => {
      setVisible(true);
    };
  
    const onClose = () => {
      setVisible(false);
    };
  
  
    return (
      <div className="inside-main-content">
        <AdminBreadCrumb />
  
        <div className="box-style">
          <PageHeader
            ghost={false}
            onBack={() => window.history.back()}
            title="Payment Mode"
            subTitle=""
            extra={[
              <Button key="1" className="custom-button-white" shape="round" onClick={showDrawer}>
                <PlusOutlined /> Add
              </Button>,
            ]}
          ></PageHeader>
  
          <Drawer
            title="Add new payment mode"
            width={DEFAULT_MASTER_DRAWER_WIDTH}
            onClose={onClose}
            visible={visible}
            bodyStyle={{
              paddingBottom: 80,
            }}
            destroyOnClose={true}
            closeIcon = {<><DrawableCloseIcon /></>}
          >
            <PaymentModeEntry data={paymentModeAddData} onDrawerClose={onClose} />
          </Drawer>
  
          <div className="tableView">
          <div className="form-content">
            <PaymentModeList />
          </div>
          </div>
  
        </div>
      </div>
    )
}

export default PaymentMode